//? Because we're rewriting methods from vendor, we can't dynamically import this file
import './catalog-jquery';

import { buildStars } from 'Functions/rating';
import { updateLazy } from 'Functions/lazy';
import { scrollToEl } from 'Functions/window';
import { initCountdowns } from 'Functions/countdown';
import { onDomContentLoaded } from 'Functions/helpers';
import { initTippy } from "Functions/tippy";

import(/* webpackChunkName: "default-layout" */ "Layouts/default");
import('./filter-slider');

const attachPaginatorEvents = () => {
    for (const pagerButton of document.querySelectorAll('.pager__list .c-btn')) {
        if (pagerButton.classList.contains('is-active')) continue

        pagerButton.addEventListener('click', (event) => {
            scrollToEl(document.querySelector('.l-listing-main__content'), 0)
        })
    }
}

rEvent.on('Listing.fetchedData', () => {
    updateLazy()
    buildStars();
    attachPaginatorEvents()
    initCountdowns()
    initTippy();

    if ($('.js-pager-current-count').length) {
        $('.js-pager-current-count').html($('.listing.products').first().find('.products__item').length);
    }
})

document.querySelectorAll('.js-show-all-subcategories').forEach(trigger => (
    trigger.addEventListener('click', () => {
        trigger.parentNode.classList.add('is-active');
        trigger.classList.remove('cxs-is-visible');
    })
));

if (document.querySelector('.js-countdown')) {
    initCountdowns()
}

onDomContentLoaded(() => {
    buildStars();
    attachPaginatorEvents();
    initTippy();
});